module.exports = __webpack_public_path__ + "img/ikanoLogo.2d783b46.svg";